import React from "react"
import NestedRoute, {NestedRouteProps} from "./NestedRoute"
import {injectIntl} from "../../lang"

/**
 * A very small wrapper around `NestedRoute` that forces `useGrid={false}`.
 *
 * It keeps *all* the behaviour of `NestedRoute` (auth, permissions, title,
 * loading state) but renders the page without the Bootstrap grid, giving the
 * component full-width control of the layout.
 *
 * Typically consumed indirectly through the `withPartialRoute` HOC, but it can
 * be used directly if needed.
 */
const PartialRoute: React.FC<NestedRouteProps> = (props) => <NestedRoute useGrid={false} {...props} />

export default injectIntl(PartialRoute) as React.FC<Omit<NestedRouteProps, "intl" | "formatMessage">>
